export const indices = [
    'OSEBX.OSE',
    'I:UKX.FTSE',
    'I:DAX.GER',
    'I:DJI.DJ',
    'NI225.OSA',
];

export const commodities = [
    { symbol: 'C:PBROUSDBR\\SP.IDCENE', subtitle: 'Fat', image: 'brent' },
    { symbol: 'C:SXAUUSDOZ\\SP.IDCIND', subtitle: 'Uns', image: 'gold' },
    { symbol: 'C:PXAGUSDOZ\\SP.IDCIND', subtitle: 'Uns', image: 'silver' },
];

export const currencies = [
    { symbol: 'X:SUSDSEK.IDCFX', subtitle: 'USD/SEK', image: 'usd' },
    { symbol: 'X:SEURSEK.IDCFX', subtitle: 'EUR/SEK', image: 'eur' },
    { symbol: 'X:SGBPSEK.IDCFX', subtitle: 'GBP/SEK', image: 'gbp' },
    { symbol: 'X:SJPYSEK.IDCFX', subtitle: 'JPY/SEK', image: 'jpy' },
];

export const regions = [
    {
        id: 'SWEDEN',
        name: 'Sverige',
        default: true,
        defaultMarket: 'SSE',
        markets: [
            {
                id: 'SSE',
                name: 'Stockholmsbörsen',
                feed: 'feed.sse.quotes',
                defaultList: 'SSE_ALL',
                sources: ['winners', 'losers', 'turnover', 'largest_trades'],
                lists: [
                    { id: 'SSE_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                    { id: 'SSE_LARGE_CAP', name: 'OMX Large cap', source: 'EQUITIES_LARGE_CAP' },
                    { id: 'SSE_MID_CAP', name: 'OMX Mid cap', source: 'EQUITIES_MID_CAP' },
                    { id: 'SSE_SMALL_CAP', name: 'OMX Small cap', source: 'EQUITIES_SMALL_CAP' },
                ],
            },
            {
                id: 'FIRST_NORTH',
                name: 'First north',
                feed: 'feed.fnse.quotes',
                defaultList: 'FIRST_NORTH_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'FIRST_NORTH_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
            {
                id: 'XSAT',
                name: 'Spotlight',
                feed: 'feed.xsat.quotes',
                defaultList: 'XAST_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'XAST_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
            {
                id: 'XNGM',
                name: 'NGM Equity',
                feed: 'feed.xngm-nest.quotes',
                defaultList: 'XNGM_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'XNGM_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
            {
                id: 'XNGM_NORDIC',
                name: 'NGM Nordic SME',
                feed: 'feed.nsme-nsse.quotes',
                defaultList: 'XNGM_NORDIC_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'XNGM_NORDIC_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
        ],
    },
    {
        id: 'NORDIC',
        name: 'Norden',
        markets: [
            {
                id: 'HEX',
                name: 'Helsingforsbörsen',
                feed: 'feed.hex.quotes',
                defaultList: 'HEX_ALL',
                sources: ['winners', 'losers', 'turnover', 'largest_trades'],
                lists: [
                    { id: 'HEX_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
            {
                id: 'CSE',
                name: 'Köpenhamnsbörsen',
                feed: 'feed.cse.quotes',
                defaultList: 'CSE_ALL',
                sources: ['winners', 'losers', 'turnover', 'largest_trades'],
                lists: [
                    { id: 'CSE_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
            {
                id: 'OSE',
                name: 'Oslobörsen',
                defaultList: 'OSE_ALL',
                feed: 'feed.ose.quotes',
                sources: ['winners', 'losers', 'turnover', 'largest_trades'],
                lists: [
                    { id: 'OSE_ALL', name: 'Alla aktier', source: 'EQUITIES' },
                ],
            },
        ],
    },
    {
        id: 'USA',
        name: 'USA',
        markets: [
            {
                id: 'NYS',
                name: 'New York Stock Exchange',
                feed: 'feed.nys.quotes',
                defaultList: 'NYS_ALL',
                sources: ['winners', 'losers'],
                lists: [
                    { id: 'NYS_ALL', name: 'Alla aktier', source: 'MM_200' },
                ],
            },
            {
                id: 'NAS',
                name: 'Nasdaq',
                defaultList: 'NAS_ALL',
                sources: ['winners', 'losers'],
                feed: 'feed.nas.quotes',
                lists: [
                    { id: 'NAS_ALL', name: 'Alla aktier', source: 'MM_200' },
                ],
            },
        ],
    },
    {
        id: 'EUROPE',
        name: 'Europa',
        markets: [
            {
                id: 'GER',
                name: 'Frankfurter Wertpapierbörse',
                feed: 'feed.ger.quotes',
                defaultList: 'GER_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'GER_ALL', name: 'Alla aktier', source: 'MM_100' },
                ],
            },
            {
                id: 'EUR',
                name: 'Euronext Paris',
                feed: 'feed.eur.quotes',
                defaultList: 'EUR_ALL',
                sources: ['winners', 'losers', 'turnover'],
                lists: [
                    { id: 'EUR_ALL', name: 'Alla aktier', source: 'MM_100' },
                ],
            },
        ],
    },
];



/** WEBPACK FOOTER **
 ** /src/shared/selectedTickers.js
 **/